import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {catchError, throwError} from 'rxjs';
import {AuthService} from '../auth/auth.service';
import {ApiErrorResponse} from '../models/api-response.model';
import {NotificationService} from '../services/notification.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const notification = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isLoginRequest = req.url.includes('/auth/login');

      if (error.status === 401 && !isLoginRequest) {
        authService.logout(false);
        router.navigate(['/auth/login']);
        notification.error('Your session has expired. Please sign in again.');
        return throwError(() => error);
      }

      if (error.status === 403) {
        notification.error('Access denied. Insufficient permissions.');
        return throwError(() => error);
      }

      if (error.status === 0) {
        notification.error('Unable to connect to server. Please check your connection.');
        return throwError(() => error);
      }

      if (!isLoginRequest) {
        const apiError = error.error as ApiErrorResponse;
        const message =
          apiError?.error?.message ||
          error.error?.message ||
          error.message ||
          'Unexpected error occurred.';
        notification.error(message);
      }

      return throwError(() => error);
    })
  );
};
